import React from 'react';
import { History } from 'lucide-react';
import DrawerShell from '../DrawerShell';
import { VisitHistory } from './VisitHistory';

const ACCENT = '#071B34';

/** Branded Visit History drawer — same navy header language as referral. */
export default function VisitHistoryDrawer({
  open,
  onClose,
  patientId,
  patientName,
  activeConsultationId,
  initialTab,
}) {
  return (
    <DrawerShell
      open={open}
      onClose={onClose}
      title="Visit History"
      subtitle={patientName ? `${patientName} · completed visits` : 'Completed visits timeline'}
      eyebrow="IIT Hyderabad Hospital"
      accent={ACCENT}
      icon={<History className="h-5 w-5 text-white" />}
      width="lg"
      testId="visit-history-drawer"
    >
      <div className="p-5">
        <VisitHistory
          patientId={patientId}
          activeConsultationId={activeConsultationId}
          initialTab={initialTab}
        />
      </div>
    </DrawerShell>
  );
}
